import Morrington71 from './Morrington 7 (1).webp'
import Morrington72 from './Morrington 7 (2).webp'
import Morrington73 from './Morrington 7 (3).webp'
import Morrington74 from './Morrington 7 (4).webp'
import Morrington75 from './Morrington 7 (5).webp'
import Morrington76 from './Morrington 7 (6).webp'
import Morrington77 from './Morrington 7 (7).webp'
import Morrington78 from './Morrington 7 (8).webp'
import Morrington79 from './Morrington 7 (9).webp'
import Morrington710 from './Morrington 7 (10).webp'
import Morrington711 from './Morrington 7 (11).webp'
import Morrington712 from './Morrington 7 (12).webp'


const Morrington7images =[
Morrington71,Morrington72,Morrington73,Morrington74,Morrington75,Morrington76,Morrington77,Morrington78,Morrington79,Morrington710,Morrington711,Morrington712
]

export default Morrington7images;